/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Scim_Disable_Confirm_ButtonInputs */



/**
* | output |
* | --- |
* | "Disable SCIM" |
*
* @param {Scim_Disable_Confirm_ButtonInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const scim_disable_confirm_button = /** @type {((inputs?: Scim_Disable_Confirm_ButtonInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Scim_Disable_Confirm_ButtonInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("SCIM deaktivieren")
	return /** @type {LocalizedString} */ ("Disable SCIM")
});